//console log
const cl = e => {
  console.log(e);
};

// Random Color generator
const getRandomColor = () => {
  let letters = "0123456789ABCDEF";
  let color = "#";
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
};

// Degree --> Decimal converter
const dmsToLonLat = o => {
  let n = NaN;
  if (o) {
    let t = Number(o.degree),
      d = "undefined" != typeof o.minute ? Number(o.minute) / 60 : 0,
      l = "undefined" != typeof o.second ? Number(o.second) / 3600 : 0,
      r = o.direction || null;
    null !== r && /[SW]/i.test(r) && (t = -1 * Math.abs(t)),
      (n = 0 > t ? t - d - l : t + d + l);
  }
  return n;
};

//set null variables as empty string
const undefinedVariables = element => {
  if (element === null) {
    element = "";
    return element;
  } else if (element === undefined) {
    element = "";
    return element;
  } else {
    return element;
  }
};

//Mobile operating device detect
const getMobileOperatingSystem = () => {
  let userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return "Windows Phone";
  }

  if (/android/i.test(userAgent)) {
    return "Android";
  }

  // IOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return "IOS";
  }

  return "unknown";
};

//Sorting function
const sortArray = data => {
  //Sort par ordre alphabétique
  // data = data.sort((a, b) => {
  //   let nameA = a.name.toUpperCase();
  //   let nameB = b.name.toUpperCase();
  //   if (nameA < nameB) {
  //     return -1;
  //   }
  //   if (nameA > nameB) {
  //     return 1;
  //   }
  //   return 0;
  // });
  // return data;

  //Sort random
  for (let i = data.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [data[i], data[j]] = [data[j], data[i]];
  }
  return data;
};

//First letter capitalize
const capitalizeFirstLetter = string => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

//Remove doublons from array
const getUnique = array => {
  let uniqueArray = [];
  // Loop through array values
  for (let i = 0; i < array.length; i++) {
    if (uniqueArray.indexOf(array[i]) === -1) {
      uniqueArray.push(array[i]);
    }
  }
  return uniqueArray;
};

const convertLong = e => {
  let longStr = e.toString();
  let dmsToLonLatRegex = /[-]{0,1}[\d.]*[\d]|([NSEW])+/g;
  let longParsed = longStr.match(dmsToLonLatRegex);
  if (longParsed !== null) {
    let longParsedObj = {
      long: {
        degree: longParsed[0],
        minute: longParsed[1],
        second: longParsed[2],
        direction: longParsed[3]
      }
    };
    return longParsedObj;
  }
};

const convertLat = e => {
  let latStr = e.toString();
  let dmsToLonLatRegex = /[-]{0,1}[\d.]*[\d]|([NSEW])+/g;
  let latParsed = latStr.match(dmsToLonLatRegex);
  if (latParsed !== null) {
    let latParsedObj = {
      lat: {
        degree: latParsed[0],
        minute: latParsed[1],
        second: latParsed[2],
        direction: latParsed[3]
      }
    };
    return latParsedObj;
  }
};

const trimToLowerCase = e => {
  e = e.split(/\s/).join("");
  e = e.toLowerCase();
  return e;
};

const flashSaleCountdown = thisCountdown => {
  // Set the date we're counting down to
  const countDownDate = new Date(
    thisCountdown.getAttribute("data-finish")
  ).getTime();
  const countdown = thisCountdown;

  function updateCountdown() {
    // Get today's date and time
    const now = new Date().getTime();

    // Find the distance between now and the count down date
    const distance = countDownDate - now;

    if (distance < 0) {
      countdown.innerHTML = "Terminé";
      clearInterval(x);
      return;
    }

    // Time calculations for days, hours, minutes and seconds
    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    // Output the result in an element with id="demo"
    countdown.innerHTML = `Reste ${hours}h ${minutes}m ${seconds}s`;
  }
  updateCountdown();
  let x = setInterval(updateCountdown, 1000);
};

const makeScrollbar = (element, theme, fade) => {
  let instance = OverlayScrollbars(element, {
    className: theme,
    scrollbars: {
      autoHide: 'leave',
      autoHideDelay: 400
    },
    callbacks: {
      onInitialized: function (e) {
        if (fade === true) {
          let topFade = document.createElement('div');
          topFade.setAttribute('class', 'scroll-topFade');
          topFade.style.opacity = '0';
          let bottomFade = document.createElement('div');
          bottomFade.setAttribute('class', 'scroll-bottomFade');
          element.prepend(topFade, bottomFade);
        }
      },
      onScroll: function (e) {
        element.dataset.scrollposition = this.scroll().position.y;
        if (fade === true) {
          let scroll_y = this.scroll().ratio.y;
          let topFade = element.querySelectorAll('.scroll-topFade')[0];
          let bottomFade = element.querySelectorAll('.scroll-bottomFade')[0];
          if (scroll_y > 0.9) {
            let scroll_y_opacity = 10 - scroll_y * 10;
            bottomFade.style.opacity = scroll_y_opacity;
          }
          if (scroll_y < 0.1) {
            let scroll_y_opacity = scroll_y * 10;
            topFade.style.opacity = scroll_y_opacity;
          }
          if (scroll_y > 0.1 && scroll_y < 0.9) {
            topFade.style.opacity = '1';
            bottomFade.style.opacity = '1';
          }
        }
      }
    }
  });
}

const toggleMapList = (elementToSelect, elementToDeselect, elementToShow, elementToHide) => {
  if (elementToHide !== null && elementToShow !== null && elementToSelect !== null && elementToDeselect !== null) {
    elementToHide.style.display = 'none';
    elementToShow.style.display = 'block';
    elementToDeselect.classList.remove('selected');
    elementToSelect.classList.add('selected');
  }
};

const convertHexToRGBA = (hexCode, opacity) => {
  let hex = hexCode.replace('#', '');

  if (hex.length === 3) {
    hex = `${hex[0]}${hex[0]}${hex[1]}${hex[1]}${hex[2]}${hex[2]}`;
  }

  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  return `rgba(${r},${g},${b},${opacity})`;
};

export const delay = (n) => {
  n = n || 2000
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve()
    }, n)
  })
}

export const sluggify = e => {
  if (e) {
    return e
      .normalize('NFD') // split an accented letter in the base letter and the acent
      .replace(/[\u0300-\u036f]/g, '') // remove all previously split accents
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9 ]/g, '') // remove all chars not letters, numbers and spaces (to be replaced)
      .replace(/\s+/g, '_'); // separator
  }
}

export {
  cl,
  dmsToLonLat,
  getRandomColor,
  undefinedVariables,
  getMobileOperatingSystem,
  sortArray,
  capitalizeFirstLetter,
  getUnique,
  convertLong,
  convertLat,
  trimToLowerCase,
  flashSaleCountdown,
  makeScrollbar,
  toggleMapList,
  convertHexToRGBA
}
